import { DDLItem, DefDDLItem } from '@/api/common/select'
import { coordType } from './webConfig'
import { PointConvertor } from './pointConvertor'
import $ from 'jquery'
import { storedUser } from '@/api/common/auth'
import { urlSetting } from './api'
import sysLocalStorage from '@/store/localStorage'
var filterName = (pagePath: string): string => {
    var name = urlSetting.domain + '_Filter_' + pagePath
    name = name.replace('https://', '')
    name = name.replace('http://', '')
    name = name.replace(new RegExp('/', 'gm'), '_')
    name = name.replace(/\./g, '_')
    return name
}
export class jsonStoreage {
    public static setFilter = (name: string, value: any) => {
        var key = filterName(name)
        const str = JSON.stringify(value)
        sysLocalStorage.setItem(key, str)
    }
    public static getFilter = (name: string) => {
        var key = filterName(name)
        var item = sysLocalStorage.getItem(key)
        return item ? JSON.parse(item) : null
    }
    public static removeFilter = (name: string) => {
        sysLocalStorage.removeItem(filterName(name))
    }
    public static getJson = (key: string) => {
        var item = sysLocalStorage.getItem(key)
        return item ? JSON.parse(item) : null
    }
    public static setJson = (key: string, value: any) => {
        const str = JSON.stringify(value)
        sysLocalStorage.setItem(key, str)
    }
    public static remove = (key: string) => {
        sysLocalStorage.removeItem(key)
    }
}
export const toggleClass = (className: string, checkClass: string, add: boolean): string => {
    var newClass = className
    if (add) {
        if (className.indexOf(checkClass) == -1) {
            newClass = className + ' ' + checkClass
        }
    }
    else {
        if (className.indexOf(checkClass) > -1) {
            newClass = className.replace(checkClass, '')
        }
    }
    return newClass
}
export const chkFileExt = (filename: string, extList: any): boolean => {
    var index = filename.lastIndexOf(".")
    var suffix = filename.substr(index)//.pdf
    extList = extList.toLowerCase() + '.'
    if (filename != "" && extList.indexOf(suffix.toLowerCase()) < 0) {
        return false
    }
    return true
}
/** 流文件转url */
export const getObjectURL = (file: any): any => {
    let url = null
    if (window.createObjectURL != undefined) { // basic
        try {
            url = window.createObjectURL(file)
        } catch (error) {
            console.log(1, error)
        }
    } else if (window.webkitURL != undefined) { // webkit or chrome
        try {
            url = window.webkitURL.createObjectURL(file)
        } catch (error) {
            console.log(2, error)
        }
    } else if (window.URL != undefined) { // mozilla(firefox)
        try {
            url = window.URL.createObjectURL(file)
        } catch (error) {
            console.log(3, error)
        }
    }
    return url
}


export const pushAccessCode = (url: string) => {
    const code = storedUser.getAttachAccessCode()
    const newUrl = url.indexOf('?') > -1 ? `${url}&code=${code}` : `${url}?code=${code}`
    return newUrl
}
export const getCascaderValue = (allData: any[], nodeId: number): any[] => {
    // console.log('allData', allData)
    var arrRes: any[] = []
    if (allData.length == 0) {
        if (!!nodeId) {
            arrRes.unshift(nodeId)
        }
        // console.log('a', arrRes)
        return arrRes
    }
    let rev = (data: any[], nodeId: number) => {
        for (var i = 0; i < data.length; i++) {
            let node = data[i]
            if (node.value == nodeId) {
                arrRes.unshift(node.value)
                // console.log('b', arrRes, node.parent)
                if (node.parent > 0) {
                    rev(allData, node.parent)
                }
                break
            }
            else {
                if (!!node.children) {
                    rev(node.children, nodeId)
                }
            }
        }
        return arrRes
    }
    arrRes = rev(allData, nodeId)
    return arrRes
}
export const getCascaderOpts = (dataList: DDLItem[]): any[] => {
    let opts: any = []
    dataList.forEach((e: any) => {
        if (e.SubList && e.SubList.length > 0) {
            opts.push({
                parent: 0,
                value: e.Key,
                label: e.Val,
                leaf: false,
                children: e.SubList.map((m: any) => {
                    return {
                        parent: e.Key,
                        value: m.Key,
                        label: m.Val,
                        leaf: true
                    }
                })
            })
        }
        else {
            opts.push({
                parent: 0,
                value: e.Key,
                label: e.Val,
                leaf: true
            })
        }
    })
    return opts
}

/** 百度坐 标转 WGS84*/
export const getWGSCoord = (pi: { lng: any, lat: any }): { lng: any, lat: any } => {
    var convert = new PointConvertor()
    //百度 转 GCJ
    var bd = convert.BD092GCJ(pi)
    // GCJ 转 WGS
    var p = convert.GCJ2WGS(bd)
    return p
}
/** WGS84 转 百度坐标 */
export const getBdCoord = (pi: { lng: any, lat: any }): { lng: any, lat: any } => {
    var convert = new PointConvertor()
    var p: any = pi
    //输入的坐标类型
    if (coordType == 'WGS84') {
        p = convert.WGS2BD09(pi)
    }
    return p
}
export const deepCopy = (org: any): any => {
    var newObj = JSON.parse(JSON.stringify(org))
    return newObj
}
//数组深拷贝，不会影响原来的数组
export const copyArray = (org: any[]): any[] => {
    var newArr = deepCopy(org)
    return newArr
}
export const copyObject = (org: any) => {
    var obj = JSON.parse(JSON.stringify(org))
    return obj
}
export const copyDDLs = (org: any[], firstType?: number | null): DDLItem[] => {
    var list: DDLItem[] = copyArray(org)
    if (firstType != null) {
        if (list.length > 0 && list[0].Key == 0) {
            //去掉原来的首选项
            list.splice(0, 1)
        }
        //添加指定的首选项
        var fst = DefDDLItem(firstType)
        list.unshift(fst)
    }
    return list
}
export const getSubDDL = (list: DDLItem[], key: number, firstType?: number | null): DDLItem[] => {
    let child: DDLItem[] = [];
    const index = list.findIndex(e => e.Key === key)
    if (index >= 0) {
        child = list[index].SubList
        if (firstType != null) {
            if (child.length > 0 || child[0].Key == 0) {
                var fst = DefDDLItem(firstType)
                child[0].Val = fst.Val
            }
        }
    }
    return child
}
// 通过Key获取DDL中的某一项
export const getDDLItem = (list: DDLItem[], key: number): DDLItem => {
    let item: DDLItem = {
        Key: 0,
        Val: '',
        ExInfo: {
            Code: '',
            Flag1: false,
            Flag2: false,
            Explain: ''
        },
        SubList: []
    }
    const index = list.findIndex(e => e.Key === key)
    if (index >= 0) {
        item = list[index]
    }
    return item
}
export const getDDLName = (list: DDLItem[], key: number): string => {
    if (key > 0) {
        const item = getDDLItem(list, key)
        if (item.Key > 0) {
            return item.Val
        }
    }
    return ''
}
export const paramToUrl = (param: any, key?: string | null, encode?: boolean | null): string => {
    if (param == null) { return '' }
    let paramStr = ''
    const t = typeof (param)
    if (t === 'string' || t === 'number' || t === 'boolean') {
        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param)
    } else {
        // tslint:disable-next-line:forin
        for (const i in param) {
            const k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
            paramStr += '&' + paramToUrl(param[i], k, encode)
        }
    }
    return paramStr.substr(1)
}
//将度分秒合并为度数
export const mergeDegrees = (d: any, m: any, s: any): number => {
    // console.log('qq', d, m, s)
    // d = toDefaultFloat(d)
    // m = toDefaultFloat(m)
    // s = toDefaultFloat(s)
    // console.log('ww', d, Math.abs(m / 60), Math.abs(s / 3600))
    const deg = Math.abs(d) + Math.abs(m / 60) + SplitAndRound(s / 3600, 16)
    return deg
}
//取整，并且保留小数点后n位
const SplitAndRound = (a: number, n: number): number => {
    a = a * Math.pow(10, n)
    return (Math.round(a)) / (Math.pow(10, n))
}

//将度转换成为度分秒 返回实体{d:112,m:20,s:23}
export const splitDegrees = (value: any): { d: number, m: number, s: number, fmt: string } => {
    value = Math.abs(value)
    var v1 = Math.floor(value)//度  
    var v2 = Math.floor((value - v1) * 60)//分  
    var v3 = SplitAndRound((value - v1) * 3600 % 60, 6) //Math.round((value - v1) * 3600 % 60)//秒
    if (v3 >= 60) {
        v2 = v2 + 1
        v3 = v3 - 60
    }
    return { d: v1, m: v2, s: v3, fmt: v1 + '°' + v2 + '\'' + v3 + '"' };
    // return v1 + '°' + v2 + '\'' + v3 + '"'
}
export const isLongitude = (lng: any): boolean => {
    //经度，整数部分为0-180小数部分为0到6位
    var lngReg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/
    if (!lngReg.test(lng)) {
        //console.log('经度整数部分为0-180,小数部分为0到6位!');
        return false
    }
    return true
}
export const isLatitude = (lat: any): boolean => {
    //经度，整数部分为0-180小数部分为0到6位
    var latReg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/
    if (!latReg.test(lat)) {
        //console.log('纬度整数部分为0-90,小数部分为0到6位!');
        return false
    }
    return true
}
export const chkLngLat = (lng: any, lat: any): boolean => {
    //经度，整数部分为0-180小数部分为0到6位
    var lngReg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/
    if (!lngReg.test(lng)) {
        console.log('经度整数部分为0-180,小数部分为0到6位!')
        return false
    }
    //纬度,整数部分为0-90小数部分为0到6位
    var latReg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/
    if (!latReg.test(lat)) {
        console.log('纬度整数部分为0-90,小数部分为0到6位!')
        return false
    }
    return true
}
export const newGuid = (): string => {
    const S4 = (): string => {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    // return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4())
}

// 字符串转数组，字符串以逗号分隔
export const splitToList = (str: string, sp: string): string[] => {
    var ids: string[] = []
    if (str != null && str != '') {
        ids = str.split(sp).filter(d => d)//去掉空内容，false和undefined
    }
    return ids
}

// 字符串转int数组，字符串以逗号分隔
export const splitToIntList = (str: string): number[] => {
    var ids: number[] = []
    if (str != null && str != '') {
        str.split(',').map((data: string) => {
            ids.push(+data)
        })
    }
    return ids
}

// 数组顺序上下调整
export const arrayReorder = (list: any, index: number, moveUp: boolean): any => {
    if (moveUp) {
        if (index > 0) {
            let upDate = list[index - 1]
            list.splice(index - 1, 1)
            list.splice(index, 0, upDate)
        } else {
            alert('已经是第一条，不可上移')
        }
    }
    else {
        if ((index + 1) === list.length) {
            alert('已经是最后一条，不可下移')
        } else {
            let downDate = list[index + 1]
            list.splice(index + 1, 1)
            list.splice(index, 0, downDate)
        }
    }
    return list
}
export const mergeDateTimeRange = (start: string | Date, end: string | Date): string[] => {
    return dateRangeJoin(start, end, 'yyyy-MM-dd hh:mm:ss')
}
export const mergeDateRange = (start: string | Date, end: string | Date): string[] => {
    return dateRangeJoin(start, end, 'yyyy-MM-dd')
}

export const dateRangeJoin = (start: string | Date, end: string | Date, format: string): string[] => {
    if (start && end && start != '' && end != '') {
        var range: string[] = []
        range.push(dateFormat(start, format))
        range.push(dateFormat(end, format))
        return range
    }
    return []
}
export const splitDateRange = (range: string[]): any => {
    if (range && range.length > 1) {
        return { start: range[0], end: range[1] }
    }
    else {
        return { start: '', end: '' }
    }
}
export const toDefaultStr = (obj: any | null, def: string): string => {
    return (obj == null) ? def : (obj + '')
}
export const toDefaultInt = (obj: any | null, def: number): number => {
    return (obj == null) ? def : parseInt(obj)
}
export const toDefaultFloat = (obj: any | null, def: number): number => {
    return (obj == null) ? def : parseFloat(obj)
}
export const tryToStr = (obj: any | null): string => {
    return toDefaultStr(obj, '')
}
export const toTrue = (obj: any | null): boolean => {
    return tryToBool(obj, true)
}
export const toFalse = (obj: any | null): boolean => {
    return tryToBool(obj, false)
}
export const tryToBool = (obj: any | null, def: boolean): boolean => {
    return (!obj) ? def : ((obj + '') == 'true' || (obj + '') == '1')
}
export const tryToInt = (obj: any | null): number => {
    return toDefaultInt(obj, 0)
}
export const tryToFloat = (obj: any | null): number => {
    return toDefaultInt(obj, 0.0)
}
/** 转化为float，并且小数点后面保留n位,默认保留两位 */
export const fixedFloat = (obj: any | null, n?: number): number => {
    const digits = n ? n : 2
    const num = tryToFloat(obj).toFixed(digits)
    return parseFloat(num)
}
//限制输入，只能输入整数
export const replaceInt = (obj: any | null): number => {
    //去掉除了数字和点之外的字符
    obj = obj ? obj.replace(/[^\d]/g, '') : 0
    return tryToInt(obj)
}
//限制输入，只能输入数字和小数点。而且只能有一个小数点
export const replaceFloat = (obj: any | null): number => {
    //去掉除了数字和点之外的字符
    obj = obj.replace(/[^\d\.]/g, '')
    obj = cutRadixPoint(obj)
    return obj
}
//去掉多余的小数点。只能出现一个小数点
export const cutRadixPoint = (obj: any | null): number => {
    //去掉空格
    obj = obj.replace(/\s/g, '')
    var s = obj.split('.')
    var n = s.length - 1//小数点个数
    if (n > 1) {
        var pre = s[0] + "."//第一个小数点之前的字符
        if (pre == ".") {
            pre = "0."
        }
        var left = obj.substr(s[0].length);//第一个小数点之后的字符
        left = left.replace(/\./g, '')//去掉所有小数点
        s = pre + left
        return s
    }
    return obj
}
export const dateFormat = (date: Date | string, fmt: string): string => {
    if (typeof (date) === 'string') {
        date = new Date(Date.parse(date))
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    const o: any = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'ms': date.getMilliseconds()
    }
    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            const str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) || (k == 'ms') ? str : padLeftZero(str))
        }
    }
    return fmt
}
export const ageFormat = (birthDate: string | any): number => {
    if (birthDate == null || birthDate == '' || birthDate.length == 0) {
        return -1
    }
    var returnAge = 0
    const arr = birthDate.split('-')
    const birthYear: number = +arr[0]
    const birthMonth: number = +arr[1]
    const birthDay: number = +arr[2]

    const d = new Date()
    const nowYear = d.getFullYear()
    const nowMonth = d.getMonth() + 1
    const nowDay = d.getDate()

    if (nowYear == birthYear) {
        returnAge = 0 //同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay //日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1
                } else {
                    returnAge = ageDiff
                }
            } else {
                var monthDiff = nowMonth - birthMonth //月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1
                } else {
                    returnAge = ageDiff
                }
            }
        } else {
            returnAge = -1 //返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge
}
const padLeftZero = ((str: string) => {
    return prefixZero(str, 2)
})
//往前补零
export const prefixZero = ((num: string | any, n: number): string => {
    return (Array(n).join('0') + num).slice(-n)
})

/** window打开新窗口，应用于打开视频播放窗口
 * height:窗口高度
 * width:窗口宽度
 * toolbar:是否显示工具栏(yes,no)
 * menubar:是否显示菜单栏(yes,no)
 * scrollbars:是否出现滚动条(yes,no)
 * resizable:是否可以改变窗口大小(yes,no)
 * location:是否显示地址栏(yes,no)
 * status:是否显示状态栏(yes,no)
 * top,left:窗口打开时的坐标
 * */
export const openWindow = (url: any, opts?: any) => {
    let opt = opts ? opts : 'width=600,height=300,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
    window.open(url, '_blank', opt)
}
/** 
 * 打开视频播放窗口 
 * */
export const openVideo = (obj?: any) => {
    var url = '/videoPlayWin?' + paramToUrl(obj)
    var iWidth = 600
    var iHeight = 300
    var iTop = (window.screen.height - 30 - iHeight) / 2 //获得窗口的垂直位置;
    var iLeft = (window.screen.width - 10 - iWidth) / 2 //获得窗口的水平位置;
    var opts = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no,minimizeButton=no,maximizeButton=no'
    //console.log('openVideo', obj, url)
    openWindow(url, opts)
}
export const submitWaiting = (show: boolean) => {
    if ($('#divUpgradeLayer').length > 0) {
        return false
    }

    var html = '<div id="div_loadingLayer">'
    html += '<div id="div_loadingbg" style="z-index:9999; position: fixed; background: #666; filter: Alpha(Opacity=10); -moz-opacity: 0.1; opacity: 0.1; top: 0px; left: 0px;"></div>'
    // html += '<div style="z-index:9999; position: fixed; left: 47%; top: 50%; color:#fff;">'
    // html += '<div style="font-size: 100px; color:#409EFF;">&nbsp;<span><i class="el-icon-loading"></i></span></div>'
    // html += '</div>'
    html += '</div>'
    if (show) {
        if ($('#div_loadingLayer').length == 0) {
            $('body').append(html)
        }
        $('#div_loadingLayer').show();
        $('#div_loadingbg').css({ 'width': '100%', 'height': '100%' })
        $('html').attr('style', 'overflow: hidden')
    }
    else {
        $('#div_loadingLayer').hide()
        $('html').removeAttr('style')
    }
}
export const scrollBottom = (): Boolean => {
    var isLast = false
    var ele: any = document.documentElement
    var body: any = document.body
    //变量scrollTop是滚动条滚动时，距离顶部的距离
    var scrollTop = ele.scrollTop || body.scrollTop
    //变量windowHeight是可视区的高度
    var windowHeight = ele.clientHeight || body.clientHeight
    //变量scrollHeight是滚动条的总高度
    var scrollHeight = ele.scrollHeight || body.scrollHeight
    //滚动条到底部的条件
    if (scrollTop + windowHeight >= scrollHeight - 5) {
        isLast = true
    }
    return isLast
}

//实现文件拖拽添加到上传队列
/** 实现文件拖拽添加到上传队列
* 示例
this.$nextTick(() => {
    dropFile('dropAreaID', this.addFileToQueue)
    
    var addFileToQueue=(e:any)=>{
        this.up_fm_uploader.addFiles(e)
    }
}
*/
export const dropFile = (dropArea: string, callback: Function | null) => {
    var dropbox: any = document.getElementById(dropArea)
    dropbox.addEventListener("drop", (e: any) => {
        console.log(e, e.dataTransfer.files)
        // e.dataTransfer.files

        e.stopPropagation()
        e.preventDefault()
        if (callback) {
            if (e.dataTransfer.files) {
                callback(e.dataTransfer.files)
            }
        }
    })//callback, false)
    dropbox.addEventListener("dragleave", (e: any) => {
        e.stopPropagation()
        e.preventDefault()
    })
    dropbox.addEventListener("dragenter", (e: any) => {
        e.stopPropagation()
        e.preventDefault()
    })
    dropbox.addEventListener("dragover", (e: any) => {
        e.stopPropagation()
        e.preventDefault()
    })
}
var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var base64DecodeChars = new Array(
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57,
    58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6,
    7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
    25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);

//base64 加密
export const base64encode = (str: any): string => {
    var out, i, len;
    var c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";

    while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;

        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt((c1 & 0x3) << 4);
            out += "==";
            break
        }

        c2 = str.charCodeAt(i++);

        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
            out += base64EncodeChars.charAt((c2 & 0xF) << 2);
            out += "=";
            break
        }

        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3F)
    }

    return out
}
//base64 解密
export const base64decode = (str: any): string => {
    var c1, c2, c3, c4;
    var i, len, out;
    len = str.length;
    i = 0;
    out = "";

    while (i < len) {
        do {
            c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
        } while (i < len && c1 == -1);

        if (c1 == -1)
            break;

        do {
            c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
        } while (i < len && c2 == -1);

        if (c2 == -1)
            break;

        out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

        do {
            c3 = str.charCodeAt(i++) & 0xff;

            if (c3 == 61)
                return out;

            c3 = base64DecodeChars[c3]
        } while (i < len && c3 == -1);

        if (c3 == -1)
            break;

        out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

        do {
            c4 = str.charCodeAt(i++) & 0xff
            if (c4 == 61) {
                return out
            }
            c4 = base64DecodeChars[c4]
        } while (i < len && c4 == -1)

        if (c4 == -1)
            break;
        out += String.fromCharCode(((c3 & 0x03) << 6) | c4)
    }
    return out
}
/** 密码校验：密码长度8~24位，至少包含数字、字母及特殊字符中的两种。 */
export const checkPwd = (val: any): boolean => {
    //精准校验：必须含有数字、字母、特殊字符，三个缺一不可
    // let exp = new RegExp(
    // 	"(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,30}"
    // );

    //-->数字+字母；字母+特殊字符，特殊字符+数字
    var exp = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,24}$/;
    return exp.test(val);
}
/** 
 * 前端静态分页
 * totalData: 总数据
 * pageSize: 每页数据量
 * pageIndex: 当前页码
 * */
export const getPageData = (totalData: any[], pageSize: number, pageIndex: number): any[] => {
    var pageData = totalData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize)
    return pageData
}
/** 过滤数据源
 * 过滤器集合，格式：{field:'',relationType:'',value: ''}
 * field - 用于过滤的属性(字段)
 * relationType - 关联关系(比较方式)
 *    可选值：==(等于)、!=(不等于)、>、>=、<、<=、like(模糊匹配)、startWith(以它开头)、endWith(以它结尾)
 * value - 用于被比较的过滤器值
 * const filters = [
 * { field: 'name', relationType: '==', value: '王五' },
 * { field: 'score', relationType: 'startWith', value: '6' }
 * ]
*/
export const dataFiltering = (source: any[], filters: any[]): any[] => {
    // 遍历数据源
    var newSource = source.filter((obj, index) => {
        // 是否符合条件
        let isFit = true
        filters.forEach((item: any) => {
            if (isFit) {
                if (typeof (obj[item.field]) === 'undefined') {
                    isFit = false
                    return isFit
                }
                // 用于被比较的过滤器值，统一转为字符串类型，便于比较
                const compareValue = String(item.value)
                // 获取数据对象用于比较的属性值，统一转为字符串类型，便于比较
                const objValue = String(obj[item.field])
                // 判断逻辑
                if (item.relationType === '==') { // 等于
                    isFit = objValue == compareValue
                } else if (item.relationType === '!=') { // 不等于
                    isFit = objValue !== compareValue
                } else if (item.relationType === '>') { // 大于
                    isFit = objValue > compareValue
                } else if (item.relationType === '>=') { // 大于等于
                    isFit = objValue >= compareValue
                } else if (item.relationType === '<') { // 小于
                    isFit = objValue < compareValue
                } else if (item.relationType === '<=') { // 小于等于
                    isFit = objValue <= compareValue
                } else if (item.relationType === 'like') { // 模糊匹配
                    isFit = objValue.includes(compareValue)
                } else if (item.relationType === 'startWith') { // 以它开头
                    isFit = objValue.startsWith(compareValue)
                } else if (item.relationType === 'endWith') { // 以它结尾
                    isFit = objValue.endsWith(compareValue)
                }
            }
        })
        // 返回当前数据对象是否符合条件，不符合条件则被过滤掉，不会出现在最终数据中
        return isFit
    })

    // 返回过滤后的数据源
    return newSource
}
/** 获取url参数中的值*/
export const getQueryString = (str: string, key: string): any => {
    if (str) {
        var queryString = str.split('?')[1] || ''
        var arr = queryString.split('&') || []
        for (var i = 0; i < arr.length; i++) {
            var keyString = decodeURIComponent(arr[i].split('=')[0])
            var valueString = decodeURIComponent(arr[i].split('=')[1])
            if (key.toLowerCase() === keyString.toLowerCase()) {
                return valueString
            }
        }
        return
    } else {
        return
    }
}
